import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-diego-rating',
  templateUrl: './diego-rating.component.html',
  styleUrls: ['./diego-rating.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DiegoRatingComponent),
      multi: true,
    },
  ],
  imports: [NgClass, MatIcon],
})
export class DiegoRatingComponent implements ControlValueAccessor {
  @Input() diegoRatings: { name: string; icon: string }[];

  IconNames = IconNames;

  currentRating: number;

  setRating(n: number) {
    this.currentRating = n;

    // Notifies Angular to update its model
    this.onChange(this.currentRating);
    this.onTouched();
  }

  private onChange = (_v: number) => {};
  private onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(): void {
    return;
  }
}
